import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Col} from "reactstrap";

import {toast} from "react-toastify";

import {
    buildGameOptions,
    buildGameSessionWithData,
    playActiveSession
} from "../../../services/game-session/game-session-service";

import FormSection from "../../components/form-section/form-section";
import GameSessionCard from "../../components/game-session-card/game-session-card";
import {buildActivityCard} from "../../../services/activity/activity-service";
import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";

import {getPlayerGameSessionsAsync} from "../../../modules/player_game_session";
import {getPlayer, updatePlayer} from "../../../modules/player";

import {setPageTitle} from "../../../modules/application/pages";

import {parseQuery} from "../../../transformations/queryString";

import "./player-session-bank.css";
import {getActiveGameSessionId} from "../../../services/player/player-service";
import {getEntity} from "../../../services/entity/entity-service";


class PlayerSessionBank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            player: {},
            loadingGameSessions:  false,
            gameSessions: [],
            activeGameSessionId: 0,
            gameOptions: {},
            loadingSessions: true
        };

        this.setPlayer = this.setPlayer.bind(this);
        this.get = this.get.bind(this);
        this.onClickPlayActiveSession = playActiveSession.bind(this)
    }

    componentDidMount() {
        const queryString = parseQuery(window.location);

        if (queryString && queryString.message) {
            const message = queryString.message;

            toast.success(unescape(message), {
                position: toast.POSITION.TOP_CENTER
            });
        }

        if (this.props.match.params.id && parseInt(this.props.match.params.id, 10) !== this.state.player.id) {
            this.setPlayer(this.props.match.params.id);
        }
    }

    async setPlayer(playerId) {
        const {dispatch, token} = this.props;

        const player = await getEntity(dispatch, getPlayer(playerId));

        const gameOptions = await buildGameOptions(this.props);

        // const gameSessions = await getEntity(dispatch,
        //     getGameSessions([{id: `[${player.game_sessions}]`},
        //         {"is_archived": false}], "-id"), true);

        const gameSessionsResponse = await getPlayerGameSessionsAsync(playerId, token);


        let playerGameSessions = [];
        if (gameSessionsResponse.data.success) {
            playerGameSessions = gameSessionsResponse.data.player_game_sessions;
        }


        for (let index in playerGameSessions) {
            let gameSession = playerGameSessions[index];
            let activities = gameSession.activities;
            const activityCards = activities.map(activity =>
                buildActivityCard(activity, gameOptions, true));

            gameSession._activities = activities;
            gameSession._activityCards = activityCards;
            gameSession = buildGameSessionWithData(gameSession);
            playerGameSessions[index] = gameSession;
        }

        //const playerGameSessions = await getEntity(dispatch, _getPlayerGameSessions([{"player": player.id}]), true);


        // for (const gameSession of gameSessions) {
        //     gameSession._playerGameSessions = playerGameSessions.filter(
        //         playerGameSession => gameSession.id === playerGameSession.game_session);
        // }

        // buildActivityCard = (activity, gameOptions, isReadOnly, index,
        //     onClickRemove, onClickSettings, onChangeLevel,
        //     isActive, hideResults)

        const activePlayerGameSession = playerGameSessions.length > 0 &&
            playerGameSessions.reduce((activePlayerGameSession, playerGameSession) => {
                const isAtEnd = playerGameSession.active_activity_index === playerGameSession.activities.length;
                if (!isAtEnd && (playerGameSession.is_active || !activePlayerGameSession)) {
                    return playerGameSession
                }
                return activePlayerGameSession
            }, null);

        this.setState({
            player, activePlayerGameSession, playerGameSessions, gameOptions
        });

        this.setState({
            loadingSessions: false
        });

        this.props.dispatch(setPageTitle(player.name));
    }

    render() {
        const {loadingSessions} = this.state;
        return (
            <div>
                {loadingSessions && <div className='sessions_loader'>Loading... <i className='fa fa-spin fa-spinner'></i></div>}
                {!loadingSessions && <div className="px-1"><FormSection component={this.playerSessionBank()}/></div>}
            </div>
            
        );
    }

    playerSessionBank() {
        const {isTherapistRole, user, token, currentUserId} = this.props;
        const {player, playerGameSessions} = this.state;
        const activeGameSessionId = player.active_game_session && getActiveGameSessionId(player);

        const activeGameSession = playerGameSessions && playerGameSessions.length > 0 &&
        playerGameSessions.find(gameSession => activeGameSessionId === gameSession.id);
        const _gameSessions = playerGameSessions && playerGameSessions.length > 0 &&
        playerGameSessions.filter(gameSession => gameSession.id !== activeGameSessionId);

        return <div className="mp-0 container-fluid">
            <PlayerDashboardButtons player={player} activePage="sessionBank" isTherapistRole={isTherapistRole} />
            <Col className="mp-0 text-left">
                <FormSection
                    sectionLabel="Active Session"
                    component={
                        <div className="m-0 px-0 py-2 text-left container-fluid">
                            {activeGameSession &&
                            <Col className="mp-0">
                                <GameSessionCard gameSession={activeGameSession}
                                                 activities={activeGameSession._activityCards}
                                                 user={user}
                                                 player={player}
                                                //  gameOptions={gameOptions}
                                                 isSessionBank
                                                 isActive
                                                 onClickPlayActiveSession={() => {
                                                     this.onClickPlayActiveSession(player, token, currentUserId, null, activeGameSession, true)
                                                 }}
                                />                                
                            </Col>
                            }
                            {!activeGameSession &&
                            <h6 className="text-secondary">No Active Game Session</h6>
                            }
                        </div>
                    }/>
            </Col>
            {_gameSessions &&
            <Col className="mp-0 text-left">
                <FormSection
                    sectionLabel="Assigned Sessions"
                    component={
                        <div className="m-0 px-0 py-2 text-left container-fluid">
                            {_gameSessions.map(gameSession => {
                                    return <Col className="mp-0" key={gameSession.id}>
                                        <GameSessionCard gameSession={gameSession}
                                                         activities={gameSession._activityCards}
                                                         user={user}
                                                         player={player}
                                                        //  gameOptions={gameOptions}
                                                         isSessionBank
                                                         onClickPlayActiveSession={() => {
                                                             this.onClickPlayActiveSession(player, token, currentUserId, null, gameSession, false)
                                                         }}
                                                         onClickSetActive={() => {
                                                             const playerPatch = {
                                                                 active_game_session: gameSession.id
                                                             };

                                                            this.props.dispatch(
                                                                 updatePlayer(player.id, playerPatch)).then(() => {
                                                                 const {player} = this.state;
                                                                 player.active_game_session = gameSession.id;
                                                                 this.setState({player})
                                                             });
                                                         }}
                                        />
                                    </Col>
                                }
                            )}
                        </div>
                    }/>
            </Col>
            }
        </div>
    }

    gameSessionGames = (gameSessionGames, games) => {
        return games
            .filter(game => {
                return gameSessionGames && gameSessionGames.includes(game.id);
            })
            .map(game => {
                return game.name
            })
            .join(", ");
    };

    gameSessionPlayers = (gameSessionPlayers, players) => {
        const _players = players
            .filter(player => {
                return gameSessionPlayers && gameSessionPlayers.includes(player.id);
            })
            .map(player => {
                return player.name
            });
        return _players.join(", ");
    };

    gameSessionSkills = (gameSessionSkills, skills) => {
        return skills
            .filter(skill => {
                return gameSessionSkills && gameSessionSkills.includes(skill.id);
            })
            .map(skill => {
                return skill.name
            })
            .join(", ");
    };

    gameSessionPositions = (gameSessionPositions, positions) => {
        return positions
            .filter(position => {
                return gameSessionPositions && gameSessionPositions.includes(position.id);
            })
            .map(position => {
                return position.name
            })
            .join(", ");
    };

    gameSessionLevels = (gameSessionSkills, skills) => {
        return skills
            .filter(skill => {
                return gameSessionSkills.includes(skill.id);
            })
            .map(skill => {
                return skill.name
            })
            .join(", ");
    };

    async get(_action) {
        return await getEntity(this.props.dispatch, _action(), true);
    }
}

const withState = connect(state => {
    const {game, game_session, player, position, skill, user} = state;

    let games = game.games;
    let gameSessions = game_session.game_sessions;
    let players = player.players;
    let positions = position.positions;
    let skills = skill.skills;

    return {
        games: games,
        gameSessions: gameSessions,
        players: players,
        positions: positions,
        skills: skills,
        user: user,
        currentUserId: user.currentUserId,
        isTherapistRole: user.isTherapistRole,
        token: user.token
    };
});

export default withRouter(withState(PlayerSessionBank));



// WEBPACK FOOTER //
// ./src/components/containers/player-session-bank/player-session-bank.js